import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useToys } from "./Toy/ToysContext";

function OrderConfirmation() {
  const { setCart } = useToys();
  const navigate = useNavigate();
  const location = useLocation();

  const { orderNumber, firstName, lastName, noPayment } = location.state || {};

  useEffect(() => {
    if (!location.state || orderNumber == null) {
      navigate("/", { replace: true });
    }
  }, [location.state, orderNumber, navigate]);

  if (!location.state || orderNumber == null) {
    return (
      <div className="confirm-page-bg">
        <p className="text-primary">Invalid confirmation. Redirecting...</p>
      </div>
    );
  }

  return (
    <div className="app-shell page-confirm confirm-page-bg">
      <div className="confirm-popup">
        <div className="confirm-banner">
          <div className="confirm-check">
            <svg viewBox="0 0 24 24" aria-hidden>
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <div className="confirm-title">
            {noPayment ? "Order submitted!" : "Booking Confirmed!"}
          </div>
          <div className="confirm-sub">
            {noPayment ? (
              <>
                Your request has been received.
                <br />
                We&apos;ll be in touch shortly.
              </>
            ) : (
              <>
                Your water toys are reserved.
                <br />
                We&apos;ll be in touch shortly.
              </>
            )}
          </div>
        </div>
        <div className="confirm-body">
          <div className="confirm-info-row">
            <div className="confirm-info-icon">#</div>
            <div>
              <div className="confirm-info-label">Order number</div>
              <div className="confirm-info-val">{orderNumber}</div>
            </div>
          </div>
          {!noPayment && (firstName || lastName) && (
            <div className="confirm-info-row">
              <div className="confirm-info-icon">👤</div>
              <div>
                <div className="confirm-info-label">Client</div>
                <div className="confirm-info-val">
                  {firstName} {lastName}
                </div>
              </div>
            </div>
          )}
          <div className="confirm-divider" />
          <div className="confirm-email-note">
            {noPayment ? (
              <>
                You will receive a confirmation email with the next steps
                <br />
                within a few minutes.
              </>
            ) : (
              <>
                A confirmation email with your{" "}
                <strong>signed rental agreement</strong>
                <br />
                will be sent to your inbox within a few minutes.
              </>
            )}
          </div>
          <button
            type="button"
            className="confirm-done-btn"
            onClick={() => {
              setCart([]);
              navigate("/");
            }}
          >
            Done — Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderConfirmation;
